<template>
  <div class="commonQRCodeDialog">
    <el-dialog
      class="commonQRCodeDialog_dialog"
      :title="title"
      :visible.sync="visible"
      :width="(qrcodeWidth + 80) + 'px'"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      :before-close="close">
      <div class="content">
        <div v-if="description" class="description">{{ description }}</div>
        <div class="qrcode">
          <div ref="qrcode" class="qrcode_img"></div>
        </div>
        <el-button class="btn_close" @click="close">{{ closeText }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  
  export default {
    name: 'commonQRCodeDialog',
    props: {
      title: {
        type: String,
        default: '二维码'
      },
      description: {
        type: String,
        default: ''
      },
      closeText: {
        type: String,
        default: '关闭'
      },
      closeOnClickModal: {
        type: Boolean,
        default: false
      },
      closeOnPressEscape: {
        type: Boolean,
        default: false
      },
      qrcodeWidth: {
        type: Number,
        default: 240
      },
      qrcodeHeight: {
        type: Number,
        default: 240
      },
      colorDark: {
        type: String,
        default: '#000000'
      },
      colorLight: {
        type: String,
        default: '#ffffff'
      },
      correctLevel: {
        type: Number,
        default: 3,
        validator: value => [1, 2, 3, 0].includes(value)
      }
    },
    data() {
      return {
        visible: false,
        qrcode: null,
        text: ''
      }
    },
    methods: {
      generateQRCode() {
        if (!this.text) {
          this.clearQRCode()
          return
        }
        
        this.$nextTick(() => {
          this.clearQRCode()
          
          this.qrcode = new QRCode(this.$refs['qrcode'], {
            text: this.text,
            width: this.qrcodeWidth,
            height: this.qrcodeHeight,
            colorDark: this.colorDark,
            colorLight: this.colorLight,
            correctLevel: this.correctLevel
          })
        })
      },
      clearQRCode() {
        if (this.$refs['qrcode']) {
          this.$refs['qrcode'].innerHTML = ''
        }
        this.qrcode = null
      },
      open(qrText) {
        this.text = qrText || ''
        this.visible = true
        this.$nextTick(() => {
          this.generateQRCode()
        })
      },
      close() {
        this.text = ''
        this.clearQRCode()
        this.visible = false
      },
      refresh() {
        this.generateQRCode()
      }
    }
  }
</script>

<style lang="less" scoped>
  .commonQRCodeDialog_dialog /deep/ .el-dialog {
    border-radius: 4px;
  }
  
  .commonQRCodeDialog_dialog /deep/ .el-dialog__header {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px;
    height: 48px;
    border-bottom: 1px solid #EBEAEE !important;
  }

  .commonQRCodeDialog_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .commonQRCodeDialog_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }

  .commonQRCodeDialog_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .commonQRCodeDialog_dialog /deep/ .el-dialog__footer {
    padding: 0;
  }

  .content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 0 32px;
    width: 100%;
    background-color: #FAFBFC;
  }

  .description {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
    text-align: center;
    margin-bottom: 16px;
  }

  .qrcode {
    box-sizing: border-box;
    margin: 0;
    padding: 10px;
    width: 260px;
    height: 260px;
    background-color: #FFFFFF;
    border-radius: 6px;
  }

  .qrcode_img {
    width: 100%;
    height: 100%;
    background-color: #ECECEC;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    /deep/ img {
      display: block;
      max-width: 100%;
      height: auto;
    }
    
    /deep/ canvas {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .btn_close {
    margin: 24px 0 0 0;
    width: 116px;
  }
</style>